import { toNumber } from "lodash";

const colorKeys = ["blue", "green", "orange", "purple", "red"];

const colorClasses = {
  blue: {
    bg: "bg-blue-100",
    text: "text-blue-500",
  },
  green: {
    bg: "bg-green-100",
    text: "text-green-500",
  },
  purple: {
    bg: "bg-purple-100",
    text: "text-purple-500",
  },
  orange: {
    bg: "bg-orange-100",
    text: "text-orange-500",
  },
  red: {
    bg: "bg-red-100",
    text: "text-red-500",
  },
};

export default (name?: string, isDisabled?: boolean) => {
  if (isDisabled) {
    return {
      bg: "bg-gray-200",
      text: "text-gray-700",
    };
  }

  if (!name) {
    return colorClasses.blue;
  }

  const colorKey =
    colorKeys[toNumber(name.charCodeAt(0).toString()[0]) % colorKeys.length];
  return colorClasses[colorKey as keyof typeof colorClasses];
};
